

































































































import { Component, Mixins } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import { AuthModule } from "@/store/auth.module";

@Component({})
export default class SignActInstruction extends Mixins(FormValidator) {
  //
  get showInstrDialog() {
    return AuthModule.ShowInstructionSignAct;
  }
  set showInstrDialog(val) {
    AuthModule.setShowInstructionSignAct(val);
  }

  picPath(pic: string) {
    return `@/assets/sign-act-pic-ru/${pic}.png`;
  }

  get isKz() {
    return this.$i18n.locale === "kk";
  }
}
